
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider, useLanguage } from './lib/LanguageContext';
import { Header, Footer, ScrollToTop } from './components/Layout';
import ContactCTA from './components/ContactCTA';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import ServicePage from './components/ServicePage';
import { useEffect } from 'react';

function PageWrapper({ title, children }) {
  const { lang } = useLanguage();
  useEffect(() => {
    document.title = title;
  }, [title, lang]);
  return children;
}

function AppContent() {
  const { t } = useLanguage();
  const location = useLocation();

  const showCTA = !['/kontakt', '/contact'].includes(location.pathname);

  return (
    <div className="min-h-screen flex flex-col bg-white selection:bg-[#f59c01]/30 selection:text-slate-900">
      <ScrollToTop />
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={
            <PageWrapper title={t.company}>
              <Home />
            </PageWrapper>
          } />
          <Route path="/udekoerende-service" element={
            <PageWrapper title={`${t.company} - ${t.nav[1].name}`}>
              <ServicePage serviceKey="onSite" />
            </PageWrapper>
          } />
          <Route path="/smede-og-maskinforretning" element={
            <PageWrapper title={`${t.company} - ${t.nav[2].name}`}>
              <ServicePage serviceKey="metalwork" />
            </PageWrapper>
          } />
          <Route path="/kran-og-lift" element={
            <PageWrapper title={`${t.company} - ${t.nav[3].name}`}>
              <ServicePage serviceKey="crane" />
            </PageWrapper>
          } />
          <Route path="/reservedele" element={
            <PageWrapper title={`${t.company} - ${t.nav[4].name}`}>
              <ServicePage serviceKey="parts" />
            </PageWrapper>
          } />
          <Route path="/om-os" element={
            <PageWrapper title={`${t.company} - ${t.nav[5].name}`}>
              <About />
            </PageWrapper>
          } />
          <Route path="/kontakt" element={
            <PageWrapper title={`${t.company} - ${t.nav[6].name}`}>
              <Contact />
            </PageWrapper>
          } />
        </Routes>
      </main>
      {showCTA && <ContactCTA />}
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <Router>
        <AppContent />
      </Router>
    </LanguageProvider>
  );
}
